export default __webpack_public_path__ + "static/media/element_39.fb66724a.jpg";